const data = {
  id: "criminal_justice",
  title: "Criminal Justice: Sentencing & Prisons",
  intro: "Alabama has some of the strictest drug sentencing laws in the country — and some of the most creative ways to apply them. The same state that built a prison crisis also built the laws that filled it. Who those laws were built for — documented.",
  tabs: [
    {
      id: "bail_pretrial",
      label: "Bail & Pretrial",
      stats: [],
      issues: [],
      trail: []
    },
    {
      id: "sentencing",
      label: "Sentencing",
      stats: [],
      issues: [],
      trail: []
    },
    {
      id: "incarceration",
      label: "Incarceration",
      stats: [],
      issues: [],
      trail: []
    }
  ]
};
export default data;
